export const css = {
	root: '_1-Kv20WX',
	title: '_2lR6Ygus',
	cards: '_13u2qdMC',
	studyplan: '_2JAfibaF',
	' _key': 'apic-theme/apic/explore-view/chooser'
};

export default css;
